module.exports = __webpack_public_path__ + "static/media/icons-sprite.68ccbc40.svg";